import {
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { SelectModule } from 'primeng/select';
import { Country } from 'src/app/trip-calculator/models/country';
import { firstValueFrom } from 'rxjs';
import { CountryService } from 'src/app/trip-calculator/services/country.service';

@Component({
  selector: 'app-select-country',
  imports: [SelectModule, TranslocoModule, ReactiveFormsModule],
  templateUrl: './select-country.component.html',
})
export class SelectCountryComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  private countryService = inject(CountryService);
  private translocoService = inject(TranslocoService);
  countryOptions: { label: string; value: string }[] = [];

  ngOnInit() {
    this.initializeCountryOptions();

  }

  initializeCountryOptions() {
    this.countryService.getCountryList().subscribe({
      next: (countries: Country[]) => {
        // trier les pays par label
        countries.sort((a, b) => {
          const labelA = this.countryService
            .getCountryLabelByLang(a)
            .toLowerCase();
          const labelB = this.countryService
            .getCountryLabelByLang(b)
            .toLowerCase();
          return labelA.localeCompare(labelB);
        });

        this.countryOptions = countries.map((country: Country) => ({
          label: this.countryService.getCountryLabelByLang(country),
          value: country.Code,
        }));
      },
      error: async (err) => {
        console.error('error while loading countries', err);
        const errorMsg = await firstValueFrom(
          this.translocoService.selectTranslate(
            'calculator.error.loadingCountries',
          ),
        );
        this.countryOptions = [{ label: errorMsg, value: '' }];
      },
    });
  }
}
